import { xsdPathStr } from "../../globals/constants";
import { IAccessControlSettings, IPasswordSettings, ISmtpEmail, ISnmpAgent, ISystemProperties, IUser } from "../../store/api/admin/types";
import { IKeyValue } from "../../store/api/devices/types";

export const handleVersionDataUnchecked = (name: string, snmpAgentData: ISnmpAgent, snmpAgentDetails: ISnmpAgent) => {
  if (name === "snmpAgentEnable") {
    return {
      ...snmpAgentData,
      readComunity: "",
      writeComunity: "",
      engineId: "",
      userName: "",
      authProtocol: "NO_AUTH",
      privProtocol: "NO_PRIV",
      authPassword: "",
      privPassword: "",
    };
  } else if (name === "enableV2") {
    return {
      ...snmpAgentData,
      readComunity: "",
      writeComunity: "",
    };
  } else if (name === "enableV3") {
    return {
      ...snmpAgentData,
      engineId: "",
      userName: "",
      authProtocol: "NO_AUTH",
      privProtocol: "NO_PRIV",
      authPassword: "",
      privPassword: "",
    };
  }
};

export const handleVersionDataChecked = (name: string, snmpAgentData: ISnmpAgent, snmpAgentDetails: ISnmpAgent) => {
  if (name === "snmpAgentEnable") {
    return {
      ...snmpAgentData,
      port: snmpAgentDetails?.port,
      readComunity: snmpAgentDetails?.readComunity,
      writeComunity: snmpAgentDetails?.writeComunity,
      engineId: snmpAgentDetails?.engineId,
      userName: snmpAgentDetails?.userName,
      authProtocol: snmpAgentDetails?.authProtocol,
      privProtocol: snmpAgentDetails?.privProtocol,
      authPassword: snmpAgentDetails?.authPassword,
      privPassword: snmpAgentDetails?.privPassword,
    };
  } else if (name === "enableV2") {
    return {
      ...snmpAgentData,
      readComunity: snmpAgentDetails?.readComunity,
      writeComunity: snmpAgentDetails?.writeComunity,
    };
  } else if (name === "enableV3") {
    return {
      ...snmpAgentData,
      engineId: snmpAgentDetails?.engineId,
      userName: snmpAgentDetails?.userName,
      authProtocol: snmpAgentDetails?.authProtocol,
      privProtocol: snmpAgentDetails?.privProtocol,
      authPassword: snmpAgentDetails?.authPassword,
      privPassword: snmpAgentDetails?.privPassword,
    };
  }
};

export const handleSmtpDataUnchecked = (name: string, smtpEmailData: ISmtpEmail) => {
  if (name === "enableSmtp") {
    return {
      ...smtpEmailData,
      useSmtpAuth: false,
      smtpHost: "",
      smtpPort: "",
      smtpUsername: "",
      smtpPassword: "",
      emailKey: "",
      useSmtpSsl: false,
      fromEmail: "",
      useSmtpTls: false,
    };
  }
};

export const handleSmtpDataChecked = (name: string, smtpEmailData: ISmtpEmail, smtpEmailDetails: ISmtpEmail) => {
  if (name === "enableSmtp") {
    return {
      ...smtpEmailData,
      useSmtpAuth: smtpEmailDetails?.useSmtpAuth,
      smtpHost: smtpEmailDetails?.smtpHost,
      smtpPort: smtpEmailDetails?.smtpPort,
      smtpUsername: smtpEmailDetails?.smtpUsername,
      smtpPassword: smtpEmailDetails?.smtpPassword,
      emailKey: smtpEmailDetails?.emailKey,
      useSmtpSsl: smtpEmailDetails?.useSmtpSsl,
      fromEmail: smtpEmailDetails?.fromEmail,
      useSmtpTls: smtpEmailDetails?.useSmtpTls,
    };
  }
};

export const preparPayloadSystemProperties = (formData: ISystemProperties) => {
  const { systemProperties } = xsdPathStr;
  return {
    [systemProperties.name]: formData?.name || "",
    [systemProperties.location]: formData?.location || "",
    [systemProperties.contact]: formData?.contact || "",
    [systemProperties.description]: formData?.description || "",
    [systemProperties.maintenanceModeSystem]: formData?.maintenanceModeSystem ? "true" : "false",
  };
};

export const convertSettingsToSystemProperties = (formData: IAccessControlSettings) => {
  const { accessControlSettings } = xsdPathStr;
  return {
    [accessControlSettings.minimumAgeDays]: formData?.minimumAgeDays || "0",
    [accessControlSettings.expiryWarningDays]: formData?.expiryWarningDays || "0",
    [accessControlSettings.minimumLength]: formData?.minimumLength || "0",
    [accessControlSettings.reusePreventionCount]: formData?.reusePreventionCount || "0",
    [accessControlSettings.reusePreventionDays]: formData?.reusePreventionDays || "0",
    [accessControlSettings.messageOfDay]: formData?.messageOfDay || "",
    [accessControlSettings.accountLockoutEnabled]: formData?.accountLockoutEnabled,
    [accessControlSettings.accountLockoutFailedCount]: formData?.accountLockoutFailedCount || "0",
    [accessControlSettings.inactivityLogoutDurationMinutes]: formData?.inactivityLogoutDurationMinutes || "0",
    [accessControlSettings.bannerEnabled]: formData?.bannerEnabled,
    [accessControlSettings.bannerTitle]: formData?.bannerTitle || "",
  };
};

export const convertSystemPropertiesToSettings = (data: IKeyValue | undefined): IAccessControlSettings => {
  const { accessControlSettings } = xsdPathStr;
  return {
    minimumAgeDays: data ? Number(data[accessControlSettings.minimumAgeDays]) : 0,
    expiryWarningDays: data ? Number(data[accessControlSettings.expiryWarningDays]) : 0,
    minimumLength: data ? Number(data[accessControlSettings.minimumLength]) : 0,
    reusePreventionCount: data ? Number(data[accessControlSettings.reusePreventionCount]) : 0,
    reusePreventionDays: data ? Number(data[accessControlSettings.reusePreventionDays]) : 0,
    messageOfDay: data?.[accessControlSettings.messageOfDay] || "",
    accountLockoutEnabled: data?.[accessControlSettings.accountLockoutEnabled] === "true",
    accountLockoutFailedCount: data ? Number(data[accessControlSettings.accountLockoutFailedCount]) : 0,
    inactivityLogoutDurationMinutes: data ? Number(data[accessControlSettings.inactivityLogoutDurationMinutes]) : 0,
    bannerEnabled: data?.[accessControlSettings.bannerEnabled] === "true",
    bannerTitle: data?.[accessControlSettings.bannerTitle] || ""
  }
};

export const convertPasswordPropertiesToSettings = (data: IKeyValue | undefined): IPasswordSettings => {
  const { accessControlSettings } = xsdPathStr;
  return {
    minimumLength: data ? Number(data[accessControlSettings.minimumLength]) : 0
  }
};

export const GetPasswordExpiryData = (user: IUser | undefined, accessControlSettings: IAccessControlSettings): { showPasswordExpiryMessage: boolean | null, expiryDays: number } => {
  const passwordExpiryDate = user?.passExpireDate !== undefined && user?.passExpireDate !== 0 ? new Date(user.passExpireDate) : null;
  let expiryDays = 0;
  if (passwordExpiryDate) {
    let currentDate = new Date();
    const diffMs = passwordExpiryDate.getTime() - currentDate.getTime();
    expiryDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  }
  const showPasswordExpiryMessage = passwordExpiryDate && expiryDays <= accessControlSettings.expiryWarningDays;
  return {
    showPasswordExpiryMessage,
    expiryDays
  };
};


export const groupPayload = (formData: IKeyValue) => {
  return {
    groupName: formData?.groupName || ""
  };
};




export const labelPayload = (formData: IKeyValue) => {
  return {
    labelName: formData?.labelName || ""
  };
};

export const syslogReceiverDefault = {
  hostname: "",
  port: 514,
  description: "",
  enabled: true,
  enableAuditTrail: true,
  enableSystemEvent: true,
};
